export function chartOverlayDefs(strategy, params = {}) {
  const defs = typeof strategy?.chartOverlays === 'function'
    ? strategy.chartOverlays(params)
    : strategy?.chartOverlays;
  return Array.isArray(defs) ? defs : [];
}

export function chartOverlaySeries(strategy, indicators = {}, params = {}) {
  return chartOverlayDefs(strategy, params).map((def) => ({
    id: def.key,
    label: def.label,
    colorKey: def.colorKey || 'primary',
    lineStyle: def.lineStyle || 'solid',
    lineWidth: def.lineWidth || 1,
    values: Array.isArray(indicators?.[def.key]) ? indicators[def.key] : [],
  }));
}

export function hasFvgBoxes(fvgSeries) {
  return Array.isArray(fvgSeries) && fvgSeries.some((g) => g && Number.isFinite(g.top) && Number.isFinite(g.bottom));
}

export function hasSessionBoxes(boxes) {
  return Array.isArray(boxes) && boxes.some((b) => Number.isFinite(b?.high) && Number.isFinite(b?.low));
}

export function chartLegendItems(overlays = [], { showFvg = false, showSession = false, colors = {} } = {}) {
  const items = overlays
    .filter((overlay) => (overlay.values || []).some(Number.isFinite))
    .map((overlay) => ({
      id: overlay.id,
      label: overlay.label,
      color: overlay.color || colors[overlay.colorKey] || colors.primary,
      kind: 'line',
      dashed: overlay.lineStyle === 'dashed',
    }));
  if (showFvg) {
    items.push({
      id: 'fvg',
      label: 'Fair value gap',
      kind: 'fvg',
      color: colors.success,
    });
  }
  if (showSession) {
    items.push({
      id: 'session',
      label: 'Session',
      kind: 'session',
      color: colors.primary || '#6366F1',
    });
  }
  return items;
}
